"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Splits8 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("../../../icons");
var Split_1 = require("../../bricks/Split");
var Splits8 = function (_a) {
    var preheading = _a.preheading, heading = _a.heading, paragraph = _a.paragraph, linkText = _a.linkText, link = _a.link, image = _a.image, channel = _a.channel, videoId = _a.videoId, url = _a.url;
    return ((0, jsx_runtime_1.jsxs)(Split_1.Split, __assign({ bgImage: image, channel: channel, videoId: videoId, url: url, textSide: "right", textWidth: "sm" }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: "h6 heading-badge mb-6" }, { children: preheading })), (0, jsx_runtime_1.jsx)("h2", __assign({ className: "display-3 lh-1-125 mb-7" }, { children: heading })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "h3 opacity-60 lh-1-5 mb-7" }, { children: paragraph })), (0, jsx_runtime_1.jsxs)("a", __assign({ href: link, className: "lead btn-link fw-light text-default" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: linkText }), (0, jsx_runtime_1.jsx)(icons_1.TailRight32, { className: "opacity-60 btn-icon-suffix" })] }))] })));
};
exports.Splits8 = Splits8;
